import { Dialog, IconButton, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { CrossClose } from "src/assets/icons";
import Container from "./Container";
import { SxProps } from "@mui/system";
import { Theme } from "@mui/material/styles";

interface ModalLayoutProps {
  isOpen?: boolean;
  onClose?: () => void;
  sx?: SxProps<Theme>;
  withPaper?: boolean;
  zIndex?: number;
  paddingContainer?: number;
  paperSx?: SxProps<Theme>;
  hideBackdrop?: boolean;
  fullScreen?: boolean;
  mobileHeight?: string;
}

const ModalLayout: React.FC<ModalLayoutProps> = ({
  children,
  sx,
  onClose,
  isOpen = true,
  withPaper = true,
  zIndex = 5000,
  paddingContainer,
  paperSx,
  hideBackdrop,
  fullScreen,
  mobileHeight,
}) => {
  const theme = useTheme();
  const isLargeScreenDown = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <Dialog
      fullScreen={fullScreen ?? isLargeScreenDown}
      fullWidth={true}
      open={isOpen}
      sx={{ zIndex: zIndex }}
      hideBackdrop={hideBackdrop}
      PaperProps={{
        sx: {
          height: { xs: mobileHeight ? mobileHeight : "100%", lg: "80%" },
          ...paperSx,
        },
      }}
    >
      <Container
        elevation={0}
        isWithPaper={withPaper}
        p={paddingContainer || 3}
        fullHeight
        sx={sx}
      >
        {onClose && (
          <IconButton
            sx={{
              position: "absolute",
              top: "10px",
              right: "10px",
              zIndex: 1301,
            }}
            onClick={onClose}
          >
            <CrossClose color="#ACACAC" />
          </IconButton>
        )}

        {children}
      </Container>
    </Dialog>
  );
};

export default ModalLayout;
